import { useContext, useEffect, useState } from 'react'

import { Box } from '@fairfashion/design-system'

import { AuthContext } from '../../contexts/auth'

import { LoginHome } from './components/LoginHome/login-home.comp'
import { ServiceTermsModal } from './components/ServiceTermsModal/service-terms-modal.comp'

export const Login = () => {
  const [showTermsModal, setShowTermsModal] = useState(false)

  const { termsError, serviceTermsCompanyId } = useContext(AuthContext)

  useEffect(() => {
    if (termsError) {
      setShowTermsModal(true)
    }
  }, [termsError, serviceTermsCompanyId])

  return (
    <Box
      position="relative"
      width="100vw"
      height="100vh"
      justifyContent="center"
      alignItems="center"
    >
      <LoginHome />
      {serviceTermsCompanyId && (
        <ServiceTermsModal
          open={showTermsModal}
          onClose={() => setShowTermsModal(false)}
          companyId={serviceTermsCompanyId}
        />
      )}
    </Box>
  )
}
